import { Box, Flex, Text } from "@chakra-ui/core";
import React from "react";
import { IconContext } from "react-icons/lib";
import styles from "./NavItem.module.css";
import { Link, NavLink } from "react-router-dom";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
export const SideMenu = ({ menu, title, icon, match }) => {
  const [showSubMenu, setShowSubMenu] = React.useState(false);

  const onExpandNav = () => setShowSubMenu(!showSubMenu);

  return (
    <Flex onClick={onExpandNav} direction='column' cursor='pointer' w='100%'>
      <Flex align='center'>
        <IconContext.Provider value={{ color: "white", size: "36px" }}>
          <Box as={icon} d='flex' ml='6' mb='7px'></Box>
        </IconContext.Provider>
        <Text
          fontSize={["14px", "14px"]}
          color='white'
          my='4'
          px={["5px", "20px"]}
          w='100%'
          ml='4'
        >
          {title}
        </Text>
        {!showSubMenu ? (
          <IconContext.Provider value={{ color: "white", size: "24px" }}>
            <Box as={FiChevronDown} d='flex' mr='10' mb='2px'></Box>
          </IconContext.Provider>
        ) : (
          <IconContext.Provider value={{ color: "white", size: "24px" }}>
            <Box as={FiChevronUp} d='flex' mr='10' mb='2px'></Box>
          </IconContext.Provider>
        )}
      </Flex>

      {menu.map((menu, i) => {
        return (
          <Flex
            align='center'
            w='100%'
            display={showSubMenu ? "flex" : "none"}
            key={i}
          >
            <Box w='100%'>
              <NavLink
                to={`${match.url}/${menu.path}`}
                activeClassName={styles.Active}
                exact
              >
                <Flex align='center'>
                  <Text
                    fontSize={["14px", "14px"]}
                    color='white'
                    my='4'
                    px={["30px", "40px"]}
                  >
                    {menu.name}
                  </Text>
                </Flex>
              </NavLink>
            </Box>
          </Flex>
        );
      })}
    </Flex>
  );
};
